import KubewardenModel from '../plugins/kubewarden/policy-class';

export default class AdmissionPolicy extends KubewardenModel {
}
